export default "__VITE_ASSET__CD3X$59B__"